import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import moment from 'moment';
import { EditButton } from '../../Buttons/EditButton';
import { ViewButton } from '../../Buttons/ViewButton';
import { DeleteButton } from '../../Buttons/DeleteButton';

export const getPermissionsColumns = (
  onClickDelete: Function,
  onClickEdit: Function,
  onClickView: Function,
): GridColDef[] => {
  return [
    {
      field: 'id',
      headerName: 'ID',
      minWidth: 100,
    },
    {
      field: 'name',
      headerName: 'Permissions',
      minWidth: 150,
    },
    {
      field: 'description',
      headerName: 'Description',
      minWidth: 150,
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      minWidth: 150,
      renderCell: (params) => {
        const data = params.row.created_at;
        return (
          <>
            <span>{moment(data).format('MMMM Do YYYY, h:mm:ss a')}</span>
          </>
        );
      },
    },
    {
      field: 'updated_at',
      headerName: 'Updated At',
      minWidth: 150,
      renderCell: (params) => {
        const data = params.row.updated_at;
        return (
          <>
            <span>{moment(data).format('MMMM Do YYYY, h:mm:ss a')}</span>
          </>
        );
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      minWidth: 150,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <ViewButton onClick={() => onClickView(params.row)} />
            <EditButton onClick={() => onClickEdit(params.row)} />
            <DeleteButton
              onClick={() => {
                onClickDelete(params.row);
              }}
            />
          </>
        );
      },
    },
  ];
};
